import { SuretyBondPreview } from "@portal/api/bond/agent";
import { useFetchBondPreviews } from "@portal/api/previews";
import { DynamicDataTable } from "@portal/components/ui/DynamicDataTable/DynamicDataTable";
import { useIsMinimalBondUIEnabled } from "@portal/hooks/useIsMinimalBondUIEnabled";
import { useMemo } from "react";
import type { PreviewTableProps } from "../../shared/layouts/EntityPreviewsLayout";
import { useAdminPreviewsTable } from "../shared/useAdminPreviewsTable";
import { getBondTableColumns } from "./columns";

const getRowHref = (row: SuretyBondPreview) => `/bonds/${row.id}`;

type BondFilter = (bond: SuretyBondPreview) => boolean;

export const createAdminBondPreviews = (tableName: string, filterPredicate?: BondFilter) => {
	const AdminBondPreviews = ({ scope }: Pick<PreviewTableProps, "scope">) => {
		const { bondPreviews } = useFetchBondPreviews();
		const { data, defaultColumnFilters, scopeColumnFilters } = useAdminPreviewsTable({
			data: bondPreviews,
			filterPredicate,
			scope,
		});
		const isMinimalUIEnabled = useIsMinimalBondUIEnabled();
		const columns = useMemo(() => getBondTableColumns(isMinimalUIEnabled), [isMinimalUIEnabled]);

		return (
			<DynamicDataTable
				name={tableName}
				columns={columns}
				getRowHref={getRowHref}
				data={data}
				defaultColumnFilters={defaultColumnFilters}
				enforcedColumnFilters={scopeColumnFilters}
				loadingMessage="Loading bonds..."
				enableExportToCSV
			/>
		);
	};

	return AdminBondPreviews;
};
